export default "__VITE_ASSET__BdIQxjlm__"